// collab-service refuses any room id outside this shape
// (`pro-studio-collab-shared/src/room.ts`), so there is nothing to gain from
// connecting with one.
const ROOM_ID = /^[\w-]{1,128}$/;

export const isCollabRoomId = (id: string | undefined): id is string =>
  id !== undefined && ROOM_ID.test(id);

/**
 * Whether the Workflows table takes its rows from the draft's collab document
 * (PSTUDIO-4450) rather than Hasura: whether a session for this draft can
 * open at all. A legacy draft is keyed `customer.bot.version`, which
 * no room accepts; feeding from the document there would skip the Hasura load
 * and wait for a session that never opens.
 */
export const canFeedFromCollab = ({
  url,
  solutionVersionId,
}: {
  url: string | null;
  solutionVersionId: string;
}): boolean => !!url && isCollabRoomId(solutionVersionId);
